/**
 * @file Полноэкранный прелоудер — тот же визуал, что у лоадера
 * turbo-frame#modal[aria-busy] (стили: .preloader в _preloader.scss).
 * Элемент создаётся лениво при первом показе и добавляется в body.
 */

let element = null

/**
 * Показывает прелоудер, при необходимости создавая элемент.
 * @param {{ label?: string }} [options] — label: текст для скринридеров
 */
export function showPreloader({ label } = {}) {
  // isConnected: после Turbo-навигации body заменяется и старый элемент отрывается от DOM
  if (!element || !element.isConnected) {
    element = document.createElement('div')
    element.className = 'preloader'
    element.setAttribute('role', 'status')

    if (label) {
      const srText = document.createElement('span')
      srText.className = 'sr-only'
      srText.textContent = label
      element.appendChild(srText)
    }

    document.body.appendChild(element)
  }

  element.hidden = false
}

/** Прячет прелоудер (элемент остаётся в DOM для повторного использования). */
export function hidePreloader() {
  if (element) element.hidden = true
}
